export enum RangeFilter {
    EQUALS = 'eq',
    LT = 'lt',
    LTE = 'lte',
    GT = 'gt',
    GTE = 'gte',
}

export enum SizeClass {
    AAAA    = 'AAAA',
    AAA     = 'AAA',
    AA      = 'AA',
    A       = 'A',
    B       = 'B',
    C       = 'C',
    EMPTY   = '',
    DEFAULT = '<C',
    J4      = '4J',
    J3      = '3J',
    J2      = '2J',
    J       = 'J',
    XL      = 'XL',
    L       = 'L',
}

export enum Market {
    EU = 'EU',
    US = 'US',
    RSA = 'RSA',
    Asia = 'Asia',
}
export interface SizeClassification {
    id: string;
    label: string;
    cropId: string;
    measureId: string;
    calculationId: string;
    sizing: SizeRange[];
    market: Market;
}

export interface SizeRange {
    cartonQty?: number; //? THIS PROPERTY NAME MIGHT CHANGE
    size: SizeClass;
    lowerBound?: Boundary;
    upperBound?: Boundary;
}

export interface Boundary {
    value: number;
    operator: RangeFilter;
}

export const RangeOperatorMap: Record<RangeFilter, (a: number, b: number) => boolean> = {
    [RangeFilter.EQUALS]: (a, b) => a === b,
    [RangeFilter.LT]: (a, b) => a < b,
    [RangeFilter.LTE]: (a, b) => a <= b,
    [RangeFilter.GT]: (a, b) => a > b,
    [RangeFilter.GTE]: (a, b) => a >= b,
}